import { settingsManager } from '../../shared/settings';

export const isTermsOfUseInlineAlertingEnabled = (isMSAppHost: boolean, replyUri: string): boolean => {
  if (settingsManager.get('termsOfUseInlineAlertSetting')?.enabled) {
    return isMSAppHost;
  }

  const tenantId = new URL(replyUri).pathname.split('/')[1];
  const allowedTenants = settingsManager.get('termsOfUseInlineAlertSetting')?.enabledTenants;
  const isTermsOfUseInlineAlertingEnabledForTenant = allowedTenants?.includes(tenantId) || false;

  return isMSAppHost && isTermsOfUseInlineAlertingEnabledForTenant;
};
